import { AbstractModel } from "../base"
import { FileAttachment } from "../file/file-attachment"
import type { IFileAttachment } from "../file/file-attachment.types"
import type { ISoftware, ISoftwareData } from "./software.types"
import { Tag } from "../tag/tag"
import type { ITag } from "../tag/tag.types"

export class Software extends AbstractModel implements ISoftware {
  readonly id?: number
  readonly title: string
  readonly file: IFileAttachment
  readonly tags: ITag[] = []
  readonly created?: Date
  readonly modified?: Date

  constructor(data: ISoftwareData) {
    super()

    // Validate data
    const requiredFields: (keyof ISoftwareData)[] = ['title', 'file']
    this.validate(data, requiredFields)
    
    // Initialize object assuming data valid
    this.title = data.title!
    this.file = new FileAttachment(data.file!)

    if (data.id) {
      this.id = data.id
    }

    if (data.tags) {
      this.tags = data.tags.map((tag) => new Tag(tag))
    }

    if (data.created) {
      this.created =
        typeof data.created === 'string' ? new Date(data.created) : data.created
    }

    if (data.modified) {    
      this.modified =
        typeof data.modified === 'string' ? new Date(data.modified) : data.modified
    }
  }
}
